import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Measurement } from '../model/measurement.model';
import { ApiService } from './api.service';
import * as convertKeys from 'convert-keys';

@Injectable()
export class MeasurementService {
  measurements: Measurement[];

  constructor(
    private apiService: ApiService,
    private translate: TranslateService,
  ) {
    this.measurements = [];
  }

  private getLocalizedDisplayLabel(measurement: Measurement): string {
    const measurementName = measurement?.name?.toLowerCase();
    if (!measurementName) {
      return measurement.displayLabel;
    }

    const translationKey = `user.measurement_option.${measurementName}`;
    const translatedLabel = this.translate.instant(translationKey);

    // Fall back to the API label if the translation is missing or not yet loaded
    const isValidTranslation = typeof translatedLabel === 'string' && translatedLabel !== translationKey;
    return isValidTranslation ? translatedLabel : measurement.displayLabel;
  }

  refreshLabels() {
    this.measurements.forEach((measurement) => {
      measurement.displayLabel = this.getLocalizedDisplayLabel(measurement);
    });
  }

  async setMeasurements() {
    const { data: measurementsObject } = await this.apiService.get('measurements');
    if (this.measurements && Array.isArray(this.measurements)) {
      while (this.measurements.length > 0) {
        this.measurements.pop();
      }
    }

    if (measurementsObject) {
      Object.keys(measurementsObject).forEach((key) => {
        const measurement = convertKeys.toCamel<Measurement>(measurementsObject[key]);
        measurement.displayLabel = this.getLocalizedDisplayLabel(measurement);
        this.measurements.push(measurement);
      });
    }
  }
}
